import { render, staticRenderFns } from "./ApiItemForm.vue?vue&type=template&id=b5cb648c"
import script from "./ApiItemForm.vue?vue&type=script&lang=js"
export * from "./ApiItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports